// @flow

import React, { type Node, useEffect, useState, useCallback } from 'react';
import { usePaymentSpec } from '@tectonics/prs/payment-spec';
import { useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { getSpecImplementedPaymentMethods } from '@tectonics/prs/support';
import { PaymentMethodsGroup } from './payment-methods-group';
import { PaymentMethodItem } from './payment-method-item';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import volcanesLaf from '@tectonics/look-and-feel/volcanes';
import { DisplayInstructions } from './payment-method-item/display-instructions';

export function PaymentMethodSelector(): Node {
  const spec = usePaymentSpec();
  const incomingPayment = useIncomingPayment();
  const [
    selectedPaymentMethod,
    setSelectEbanxPaymentMethod,
  ] = useUserInputValue('selectedPaymentMethod');

  useEffect(() => {
    if (
      shouldUnselectPaymentMethodByCountry(spec.country) &&
      selectedPaymentMethod !== '' &&
      (incomingPayment.payment_type_code === 'all' || incomingPayment.payment_type_code === '_all')
    ) {
      setSelectEbanxPaymentMethod('');
    }
  }, [setSelectEbanxPaymentMethod]);

  const paymentMethodsCodes = getSpecImplementedPaymentMethods(spec, volcanesLaf.prsSupport);

  const [isFocused, setFocused] = useState(false);
  const flipFocus = useCallback(() => setFocused(current => !current), [setFocused]);

  if (paymentMethodsCodes.length === 1 && shouldHidePaymentMethodByCountry(spec.country))
    return (
      <DisplayInstructions
        paymentMethodCode={paymentMethodsCodes[0]}
      />
    );

  return (
    <PaymentMethodsGroup data-test-name="payment-method" focused={isFocused}>
      {paymentMethodsCodes.map((code) => (
        <PaymentMethodItem key={code} paymentMethodCode={code} handleFocus={flipFocus} />
      ))}
    </PaymentMethodsGroup>
  );
}

function shouldHidePaymentMethodByCountry(country: string): boolean {
  switch (country) {
    case 'za':
    case 'ke':
    case 'ng':
    case 'in':
    case 'tz':
    case 'ug':
    case 'zm':
    case 'eg':
    case 'gh':
    case 'jm':
      return false;

    default:
      return true;
  }
}

function shouldUnselectPaymentMethodByCountry(country: string): boolean {
  switch (country) {
    case 'ng':
    case 'ke':
    case 'tz':
    case 'ug':
    case 'zm':
    case 'eg':
    case 'gh':
    case 'jm':
      return true;

    default:
      return false;
  }
}
